/**
 * ledgerMajorUnits
 *
 * Converts integer minor units to a major-unit number of the ledger's currency (cents to dollars for USD, unchanged
 * for JPY). The digits come from `Intl.NumberFormat(...).resolvedOptions().maximumFractionDigits`, exactly as
 * `ledgerMinorUnits` takes them on the way in, so a round trip through both never changes scale. The one place a
 * minor amount is divided by its currency's scale. Consumers: `ledgerMoney`, and the proposal review's allocation
 * inputs in react, whose bounds are major units.
 */

export const ledgerMajorUnits = (minor: number, currency: string): number => {
    const digits = new Intl.NumberFormat('en-US', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits ?? 0;
    return minor / 10 ** digits;
};
